import 'whatwg-fetch';

export default async function callApi(
  method: string,
  path: string,
  data?: object
) {
  const response = await fetch(`/api/1${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
    credentials: 'include',
  });
  if (response.status !== 200) {
    let message = await response.text();
    if (message.startsWith('{')) {
      message = JSON.parse(message).data;
    }
    throw new Error(`${response.status} ${response.statusText}. ${message}`);
  }
  const json = await response.json();
  return json;
}
